import { PartnerClientsPageCancelledDictionary } from 'types/i18n';

export const partnerDashboardPageCancelledDictionaryRu: PartnerClientsPageCancelledDictionary = {
  fallbackTitle: 'Пусто',
  fallbackDescription:
    'Общайтесь с клиентами и помогайте интегрировать программу AGM.\nТогда клиент продолжит использовать программу и приносить вам доход.',
  clientsStatText(clientsCount, licensesCount) {
    return `Подписка отменена: ${clientsCount} / Лицензий: ${licensesCount}`;
  },
  standardDescription:
    'Клиента, который отменил подписку, нужно вернуть в течение 14 дней. Затем он будет утерян.',
};
